import script from "./EditorLandingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorLandingPage.vue?vue&type=script&setup=true&lang=js"

import "./EditorLandingPage.vue?vue&type=style&index=0&id=4255e7c7&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4255e7c7"]])

export default __exports__